// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__17owG","inputDescription":"styles_inputDescription__3WLph"};